import { Headings } from "./Headings";
import { Paragraphs } from "./Paragraphs";

export const Text = () => (
  <div className="divide-primary h-full w-[23rem] divide-y overflow-y-auto">
    <div className="px-6 pt-5">
      <Headings />
      <Paragraphs />
    </div>
  </div>
);
